import { Form, Modal } from "react-bootstrap";
import styled from "styled-components";
import PhoneInput from 'react-phone-number-input'
import { StyledInputText as BaseStyledInputText } from '../styles';

export const birthDatePickerTextFieldSx = {
  backgroundColor: '#f1f1f1',
  borderRadius: '0.625rem',
  width: '100%',
  boxSizing: 'border-box',
  '& .MuiOutlinedInput-root': {
    width: '100%',
    height: 54,
    minHeight: 54,
    maxHeight: 54,
    padding: 0,
    borderRadius: '0.625rem !important',
    color: '#3C4043',
    '& fieldset': {
      border: '2px solid #c9c9c9',
      borderRadius: '0.625rem',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: '2px solid #c9c9c9',
      borderRadius: '0.625rem',
    },
    '&:hover fieldset': {
      borderColor: '#c9c9c9',
    },
    '&.Mui-focused fieldset': {
      border: '2px solid #c9c9c9',
    },
    '&.Mui-disabled': {
      backgroundColor: '#f1f1f1',
      cursor: 'not-allowed',
    },
    '& .MuiInputAdornment-root': {
      marginRight: 1,
    },
    '& .MuiIconButton-root': {
      padding: 1,
      marginRight: 0,
    },
  },
  '& .MuiInputBase-input': {
    padding: '10px',
    fontSize: 16,
    borderRadius: '0.625rem',
  },
  '& .MuiPickersInputBase-root': {
    width: '100%',
    boxSizing: 'border-box',
    height: 54,
    minHeight: 54,
    maxHeight: 54,
    padding: '0 0 0 10px',
    borderRadius: '0.625rem',
    border: '2px solid #c9c9c9',
    overflow: 'hidden',
    backgroundColor: '#f1f1f1',
    color: '#3C4043',
    '&:hover': {
      borderColor: '#c9c9c9',
    },
    '&.Mui-focused': {
      borderColor: '#c9c9c9',
    },
    '&.Mui-disabled': {
      backgroundColor: '#f1f1f1',
      cursor: 'not-allowed',
    },
  },
  '& .MuiPickersOutlinedInput-notchedOutline': {
    border: 'none',
    borderRadius: '0.625rem',
  },
  '& .MuiPickersInputBase-input': {
    padding: '10px 0',
    fontSize: 16,
  },
  '& .MuiPickersOutlinedInput-root .MuiIconButton-root': {
    flex: '0 0 32px',
    width: 32,
    height: 32,
    marginLeft: 'auto',
    marginRight: 0,
    padding: 6,
    borderRadius: '1em',
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
};

export const StyledModal = styled(Modal)`
  

  .modal-title, .modal-body, .modal-footer {
    color: #3C4043; 
  }
`;

export const StyledSelect = styled(Form.Select)`
  padding: 10px;
  border-radius: 6px;
  background:  #F1F1F1;
  color: #3C4043; 
  font-size: 16px;
  min-height: 52px;
  
  option{
    font-size: 18px;
    padding: 1em 0;
  }
`;


export const StyledSelectEmployee = styled(Form.Select)`
  padding: 10px;
  border-radius: 6px;
  background:  #2A2A48;
  border-color: #23233C;
  color: #FFF; 
  font-size: 16px;
  min-height: 52px;
  
  option{
    font-size: 18px;
    padding: 1em 0;
  }
`;


export const StyledSelectModalUser = styled(Form.Select)`
  width: 100%;
  padding: 10px;
  font-size: 16px;
  color: #3C4043;
  border-radius: 0.625rem;
  background-color: #f1f1f1;
  border: 2px solid #c9c9c9;
  outline: none;
  box-sizing: border-box;
  height: 54px;
  min-height: 54px;
  max-height: 54px;
  

  &:hover {
    border-color: #c9c9c9;
  }

  &:focus {
    border-color: #c9c9c9; /* Cinza mais escuro no foco */
    box-shadow: none;
  }

  &:disabled {
    background-color: #f1f1f1;
    cursor: not-allowed;
  }

  option{
    font-size: 18px;
    padding: 1em 0;
  }

  option:hover{
    background-color: #CCCCCF;
  }

  option:checked {
  background-color: #CCCCCF;
  color: #3C4043;
  }
`;

type FieldStateProps = {
  $hasError?: boolean;
};

export const StyledInputTextModalUser = styled(BaseStyledInputText)<FieldStateProps>`
  ${({ $hasError }) =>
    $hasError &&
    `
      border-color: #dc3545;
      box-shadow: 0 0 0 0.15rem rgba(220, 53, 69, 0.12);

      &:focus {
        border-color: #dc3545;
        box-shadow: 0 0 0 0.15rem rgba(220, 53, 69, 0.12);
      }
    `}
`;

export const StyledInputCellphoneAddUser = styled(PhoneInput)<FieldStateProps>`
  .PhoneInputInput{
    font-size: 16px;
    border-radius: 10px;
    width: 100%;
    outline: none;
    transition: box-shadow ease .25s, border-color ease .25s;
    min-height: 54px;
    max-height: 54px;
    background: #F1F1F1;
    color: #3C4043;
    width: 100%;
    border: 2px solid #c9c9c9;
    padding: 10px;
  }

  ${({ $hasError }) =>
    $hasError &&
    `
      .PhoneInputInput {
        border-color: #dc3545;
        box-shadow: 0 0 0 0.15rem rgba(220, 53, 69, 0.12);
      }

      .PhoneInputInput:focus {
        border-color: #dc3545;
        box-shadow: 0 0 0 0.15rem rgba(220, 53, 69, 0.12);
      }

      .PhoneInputCountry {
        border-color: #dc3545;
      }
    `}

  &:disabled {
    color:rgb(173, 173, 173);
    cursor: not-allowed;
  }

  .PhoneInputInput:disabled{
    color:rgb(173, 173, 173);
    cursor: not-allowed;
  }

  .PhoneInputInput:focus{
    border: 2px solid #c9c9c9;
    box-shadow: none;
  }

  .PhoneInputCountry{
    margin-right: .5em;
    padding: 0 .2em 0 .5em !important;
    font-size: 18px;
    border-radius: 10px;
    outline: none;
    padding: 10px;
    transition: box-shadow ease .25s, border-color ease .25s;
    min-height: 54px;
    max-height: 54px;
    background:  #F1F1F1;
    color:  #FFF;
    border: 2px solid #c9c9c9;
  }

 

  .PhoneInputCountry:focus{	
    border: 2px solid #c9c9c9;
    box-shadow: none;
  }

  .PhoneInputCountrySelectArrow{
    color: #3C4043;
  }
    

  .PhoneInputCountrySelect{
    opacity: 0 !important;
  }

`

export const StyledOption = styled.option`
  padding: 1em 0;
  font-size: 16px;
  
`;
